export default __webpack_public_path__ + "images/8906a0b4fbb9e815319ce59db23cae02-djdance.webp";